import React from 'react';

export default class PasswordService {

  static checkPassStrenght(password) {

    // Create an array and push all possible passwords that you want in password
    let matchedCase = new Array();
    matchedCase.push("[$@$!%*#?&]"); // Special Charector
    matchedCase.push("[A-Z]");      // Uppercase Alphabates
    matchedCase.push("[0-9]");      // Numbers
    matchedCase.push("[a-z]");     // Lowercase Alphabates

    // Check the conditions
    let ctr = 0;
    for (let i = 0; i < matchedCase.length; i++) {
      if (new RegExp(matchedCase[i]).test(password)) {
        ctr++;
      }
    }
    // Display it
    let color = "";
    let strength = "";
    switch (ctr) {
      case 0:
      case 1:
      case 2:
        strength = "WEAK";
        color = "red";
        break;
      case 3:
        strength = "MEDIUM";
        color = "orange";
        break;
      case 4:
        strength = "STRONG";
        color = "green";
        break;
    }
    // Do not show anything when the length of password is zero.
    if (password.length === 0) {
      color = "";
      strength = "";
    }
    return {
      strength,
      color
    }
  }


  static validatePassword(pswd) {
    if(pswd.length == 0){
      throw new Error('Please enter a password');
    } else if(pswd.length < 12){
      throw new Error('Your password must be at least 12 characters long');
    }

    // Validate byte length
    if(typeof TextEncoder !== 'undefined') {
      const encoder = new TextEncoder()
      const view = encoder.encode(pswd);
      if(view.length > 71) {
        throw new Error('Your password is too long');
      }
    }

    return true;
  }

}



// WEBPACK FOOTER //
// ./src/common/script/services/PasswordService.js